import { useRecoilState } from 'recoil'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import projectCheckpointsApi from '../projectCheckpoints.api'
import { IProjectCheckpointCriterion } from '../projectCheckpoints.types'
import { useEffect, useMemo } from 'react'
import checkpointsCriteriaAtom from '../checkpointsCriteria.atom'

export const useCheckpointCriteriaState = (checkpointId: string | undefined) => {
  const [state, setState] = useRecoilState(checkpointsCriteriaAtom)

  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (!checkpointId || state.items[checkpointId]) {
      return
    }

    wait(projectCheckpointsApi.getCriteria(checkpointId), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: { ...prev.items, [checkpointId]: resp.body } }))
      }
    })
  }, [checkpointId])

  const addItem = (item: IProjectCheckpointCriterion) => {
    if (!checkpointId) return
    setState((prev) => ({ ...prev, items: { ...prev.items, [checkpointId]: [...(prev.items[checkpointId] || []), item] } }))
  }

  const criteriaMap: Record<string, IProjectCheckpointCriterion> = useMemo(
    () => (checkpointId && state.items[checkpointId])?.reduce((map, criterion) => ({ ...map, [criterion.id]: criterion }), {}) || {},
    [state.items, checkpointId]
  )

  const criteriaState = useMemo(() => (checkpointId ? state.items[checkpointId] || [] : []), [state.items, checkpointId])

  return { criteriaState: criteriaState, loading, criteriaMap, addItem }
}
